export default "__VITE_ASSET__gAzsd6TCDgp86c4KxVAHMw__";